import { mmFetch } from './mmFetch';
import { mmFetchWithResponse } from './mmFetchWithResponse';

class FBMSubstitutionRulesV1Api {
    constructor() {
        this.baseUrl = 'api/fbm/v1/substitution/rules';
    }

    async bulkUpload(file, fbmAccountName) {
        const respObj = { data: {}, msg: '', status: false };

        try {
            const formData = new FormData();
            formData.append('file', file);

            const url = `${this.baseUrl}/bulk/upload?fbmAccount=${encodeURIComponent(fbmAccountName)}`;
            const response = await mmFetch(url, {
                body: formData,
                headers: {}, // Let browser set Content-Type for multipart
                method: 'POST',
            });

            if (response.status === 200) {
                const decodedResp = await response.json();
                respObj.status = true;
                respObj.msg = decodedResp.msg;
                respObj.data = decodedResp.data;
            } else {
                try {
                    const decodedResp = await response.json();
                    respObj.msg = decodedResp.msg || 'Upload failed';
                } catch (error) {
                    console.error('Error decoding response:', error);
                    respObj.msg = `Upload failed with status ${response.status}`;
                }
            }
        } catch (e) {
            // Re-throw AbortError so TanStack Query can handle cancellation
            if (e.name === 'AbortError') {
                throw e;
            }
            respObj.msg = `Upload error: ${e.message}`;
        }

        return respObj;
    }

    async bulkFetch(key, fbmAccountName, signal) {
        const url = `${this.baseUrl}/bulk/fetch?key=${encodeURIComponent(key)}&fbmAccount=${encodeURIComponent(fbmAccountName)}`;
        return mmFetchWithResponse(url, { signal });
    }

    async bulkEdit(key, fbmAccountName, rowsToUpdate, rowsToDelete) {
        const url = `${this.baseUrl}/bulk/edit?fbmAccount=${encodeURIComponent(fbmAccountName)}`;
        return mmFetchWithResponse(url, {
            body: JSON.stringify({
                key,
                rowsToDelete,
                rowsToUpdate,
            }),
            method: 'PUT',
        });
    }

    async bulkPersist(key, fbmAccountName) {
        const url = `${this.baseUrl}/bulk/persist?fbmAccount=${encodeURIComponent(fbmAccountName)}`;
        return mmFetchWithResponse(url, {
            body: JSON.stringify({ key }),
            method: 'PUT',
        });
    }

    async getRules(fbmAccountName, facilityId, week, year) {
        const url = `${this.baseUrl}/mgmt/list?fbmAccount=${encodeURIComponent(fbmAccountName)}&facilityId=${encodeURIComponent(facilityId)}&week=${encodeURIComponent(week)}&year=${encodeURIComponent(year)}`;
        return mmFetchWithResponse(url, { method: 'GET' });
    }

    async getEvents(fbmAccountName, facilityId) {
        const url = `${this.baseUrl}/mgmt/events?fbmAccount=${encodeURIComponent(fbmAccountName)}&facilityId=${encodeURIComponent(facilityId)}`;
        return mmFetchWithResponse(url, { method: 'GET' });
    }

    async toggleRuleFacilityStatus(fbmAccountName, facilityId, ruleGroupId, isEnabled) {
        const url = `${this.baseUrl}/mgmt/facility-status?fbmAccount=${encodeURIComponent(fbmAccountName)}`;
        return mmFetchWithResponse(url, {
            body: JSON.stringify({
                facilityId,
                ruleGroupId,
                isEnabled,
            }),
            method: 'PUT',
        });
    }

    async deleteRuleGroup(fbmAccountName, ruleGroupId) {
        const url = `${this.baseUrl}/mgmt/rule-group/${encodeURIComponent(ruleGroupId)}?fbmAccount=${encodeURIComponent(fbmAccountName)}`;
        return mmFetchWithResponse(url, { method: 'DELETE' });
    }
}

export const fbmSubstitutionRulesV1Api = new FBMSubstitutionRulesV1Api();
export { FBMSubstitutionRulesV1Api };
